import { render } from "./_list.vue?vue&type=template&id=5d1cf1ac&scoped=true"
import script from "./_list.vue?vue&type=script&lang=js"
export * from "./_list.vue?vue&type=script&lang=js"

import "./_list.vue?vue&type=style&index=0&id=5d1cf1ac&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1cf1ac"]])

export default __exports__